module.exports = __webpack_public_path__ + "img/hzico_6.27fe6ac4.jpg";